import React, { useState } from 'react';
import AuthLayout from '../../layouts/AuthLayout';
import { supabase } from '../../supabaseClient';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) throw error;
      alert('Registration successful! Please check your email to confirm.');
      window.location.href = '/login';
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Start categorizing unstructured data in minutes"
      footer={<>
        Already have an account? <a href="/login">Log in</a>
      </>}
    >
      <form onSubmit={handleRegister}>
        <label className="label" htmlFor="email">Email</label>
        <input className="input" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />

        <label className="label" htmlFor="password">Password</label>
        <input className="input" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Create a strong password" required minLength={6} />

        {error && <div style={{ color: '#ff6b6b', fontSize: 14 }}>{error}</div>}

        <div className="auth-actions">
          <button className="button full" type="submit" disabled={loading}>{loading ? 'Creating…' : 'Create account'}</button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default Register; 